<template>
	<div class="form-base">
		<v-row>
			<v-col cols="12">
				<DadataOrgField
					v-model="v.name.$model"
					:errorMessages="getValidationErrorText(v.name)"
					:disabled="disabled"
					label="Наименование, указанное в ЕГРЮЛ"
					outlined
					:suggestions="suggestions"
					field="name"
					@suggest="onSelect"
					@blur="v.name.$touch"
				/>
			</v-col>

			<v-col cols="4">
				<DadataOrgField
					v-model="v.ogrn.$model"
					:errorMessages="getValidationErrorText(v.ogrn)"
					:disabled="disabled"
					mask="#############"
					label="ОГРН"
					outlined
					:suggestions="suggestions"
					field="ogrn"
					@suggest="onSelect"
					@blur="v.ogrn.$touch"
				/>
			</v-col>
			<v-col cols="4">
				<DadataOrgField
					v-model="v.inn.$model"
					:errorMessages="getValidationErrorText(v.inn)"
					:disabled="disabled"
					mask="##########"
					label="ИНН"
					outlined
					:suggestions="suggestions"
					field="inn"
					@suggest="onSelect"
					@blur="v.inn.$touch"
				/>
			</v-col>
			<v-col cols="4">
				<v-text-field
					v-model="v.kpp.$model"
					:errorMessages="getValidationErrorText(v.kpp)"
					:disabled="disabled"
					v-mask="KPP"
					label="КПП"
					outlined
					@blur="v.kpp.$touch"
				/>
			</v-col>
		</v-row>

		<AddressEGRUL :v="v" notice-recovery :disabled="disabled" :translationKey="translationKey ? `${translationKey}.egrul` : undefined"/>

		<v-row>
			<v-col cols="12">
				<v-text-field
					v-model="v.email.$model"
					:errorMessages="getValidationErrorText(v.email)"
					:disabled="disabled"
					label="Адрес электронной почты, содержащийся в ЕГРЮЛ"
					outlined
					@blur="v.email.$touch"
				/>
			</v-col>
		</v-row>

		<v-divider class="divider"></v-divider>

		<v-row>
			<v-col cols="12">
				<v-text-field
					v-model="v.changeReason.$model"
					:errorMessages="getValidationErrorText(v.changeReason)"
					:disabled="disabled"
					label="Причина изменения должника"
					this.v.regDat
					outlined
					@input="$emit('change-reason', $event)"
				/>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import {maxLength, minLength, required} from 'vuelidate/lib/validators';
import deepmerge from 'deepmerge';

import {
	EMAIL,
	getValidationErrorText,
	DATA_MATCH,
	MAX_LENGTH_EMAIL,
	EMOJI,
	INN,
	KPP, TRAILING_AND_LEADING_SPACES,
} from '@/utils/validate';
import AddressEGRUL from '@/components/services/NoticeRecovery/General/AddressEGRUL';
import {addressValidate} from '@/components/base/AddressStructuredField';
import DadataOrgField from '@/components/base/DadataOrgField';

export const organizationModel = {
	name: '',
	address: '',
	addressesMatch: false,
	factAddress: '',
	ogrn: '',
	inn: '',
	kpp: '',
	email: '',
	changeReason: '',
};

export const getOrganizationValidation = (debtor) => {
	let organizationValidation = {
		name: {
			required,
			maxLength: maxLength(1000),
			EMOJI,
			TRAILING_AND_LEADING_SPACES
		},
		address: {
			required,
			...addressValidate(),
		},
		addressesMatch: {},
		factAddress: {
			required,
			...addressValidate(),
		},
		ogrn: {
			required,
			minLength: minLength(13),
		},
		inn: {
			required,
			minLength: minLength(10),
			INN: INN(10),
		},
		kpp: {
			required,
			minLength: minLength(9),
			KPP,
		},
		email: {
			required,
			EMAIL,
			maxLength: maxLength(MAX_LENGTH_EMAIL),
			TRAILING_AND_LEADING_SPACES
		},
		changeReason: {
			maxLength: maxLength(4000),
			EMOJI,
			TRAILING_AND_LEADING_SPACES
		},
	};

	if (debtor.organization) {
		organizationValidation = deepmerge(organizationValidation, {
			ogrn: {
				DATA_MATCH: DATA_MATCH(
					debtor.organization.ogrn,
					'должник и предыдущий должник'
				),
			},
			inn: {
				DATA_MATCH: DATA_MATCH(
					debtor.organization.inn,
					'должник и предыдущий должник'
				),
			},
			kpp: {
				DATA_MATCH: DATA_MATCH(
					debtor.organization.kpp,
					'должник и предыдущий должник'
				),
			},
		});
	}

	return organizationValidation;
};

export default {
	name: 'Organization',
	components: {
		AddressEGRUL,
		DadataOrgField,
	},
	props: {
		v: Object,
		disabled: Boolean,
		translationKey: String,
	},
	data: () => ({
		suggestions: [],
		getValidationErrorText,
	}),
	methods: {
		onSelect: function (item) {
			this.suggestions = [item];
			this.v.name.$model = item.name;
			this.v.inn.$model = item.inn;
			this.v.ogrn.$model = item.ogrn;
			this.v.kpp.$model = item.kpp;

			// this.v.regDate.$model = item.regDate;
			this.v.email.$model = item.email;
			this.v.address.$model = {...item.address};
			this.v.addressesMatch.$model = true;
		}
	},
};
</script>

<style scoped></style>
